"use client"

import React, { useState } from "react"
import { Pressable, Text } from "react-native"
import clsx from "clsx"
import { styled } from "nativewind"
import { twMerge } from "tailwind-merge"

import Icon from "../Icon"
import { Box } from "../Layout"

export type StarRatingProps = {
  className?: string
  maxStars?: 4 | 5
  value?: number
  onChange?: (value: number) => void
  disabled?: boolean
  labels?: string[]
}

const Container = styled(Box)

export const StarRating = ({
  className,
  maxStars = 5,
  value = 0,
  onChange,
  disabled = false,
  labels = [],
}: StarRatingProps) => {
  const [internalValue, setInternalValue] = useState(value)
  const stars = Array.from({ length: maxStars }, (_, i) => i + 1)
  const currentValue = onChange ? value : internalValue

  const handlePress = (star: number) => {
    if (disabled) return
    if (onChange) {
      onChange(star)
    } else {
      setInternalValue(star)
    }
  }

  const label = currentValue > 0 ? labels[currentValue - 1] : undefined

  return (
    <Box style={{ alignItems: "center" }} className={className}>
      <Container
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          padding: 8,
        }}
        role="radiogroup"
        aria-disabled={disabled}
      >
        {stars.map((star) => (
          <Pressable
            key={star}
            onPress={() => handlePress(star)}
            disabled={disabled}
            accessibilityRole="radio"
            accessibilityState={{ selected: currentValue === star, disabled }}
          >
            <Icon
              type={currentValue >= star ? "star-filled" : "star-outlined"}
              size="xxxxl"
              className={twMerge(clsx("text-primary-500 transition-colors"))}
            />
          </Pressable>
        ))}
      </Container>
      {label && (
        <Box
          style={{
            marginTop: 8,
            minWidth: 80,
            borderRadius: 8,
            backgroundColor: "#E9D8FD",
            paddingHorizontal: 12,
            paddingVertical: 4,
            alignItems: "center",
          }}
        >
          <Text
            style={{
              color: "#44337A",
              fontSize: 16,
              textAlign: "center",
              fontFamily: "MaisonNeue",
              fontWeight: "500",
            }}
          >
            {label}
          </Text>
        </Box>
      )}
    </Box>
  )
}
